export const getChooseApplicantApplications = (applications = []) => {
  const sorted = [...applications];
  sorted.sort((a, b) => new Date(b) - new Date(a));
  const approved = sorted.filter((app) => app.status === 'approved');
  const unprocessed = sorted.filter((app) => !app.status);
  return [...approved, ...unprocessed];
};
